import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_JOB_REPORT_REQUEST,
  GET_JOB_REPORT_SUCCESS,
  GET_JOB_REPORT_FAILURE,
} from "../../actionTypes";

import {
  getJobReportSuccess,
  getJobReportFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* fetchJobReportaction(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/get_repot_job", action.payload)
    );
    if (response.data.status) {
      yield put(getJobReportSuccess(response.data));
    } else {
      getJobReportFailure(response.data);
    }
  } catch (error) {
    yield put(
      getJobReportFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* getJobReportSaga() {
  yield takeLatest(GET_JOB_REPORT_REQUEST, fetchJobReportaction);
}
export default getJobReportSaga;
